import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import CircularProgress from '@material-ui/core/CircularProgress'

import { fetchTemplates } from '../../../../../actions/Template'
import { fetchScript } from '../../../../../actions/Script'
import ScriptStructure from '../../../../../containers/ScriptStructure'
import ScriptLogForm from '../../../../../containers/ScriptLogForm'

class Write extends React.Component {
  componentWillMount () {
    this.props.actions.fetchScript()
    this.props.actions.fetchTemplates()
  }

  render () {
    const {scriptReady, templatesReady, match} = this.props

    if (!(scriptReady && templatesReady))
      return <div className="d-flex h-100 justify-content-center align-items-center">
        <CircularProgress/>
      </div>

    const {sceneId, slateId, takeId} = match.params

    return <div className="h-100 d-flex flex-column">

      <div className="row h-100">
        <div className="col-md-3">
          <ScriptStructure/>
        </div>
        <div className="col-md-9 my-5">
          <ScriptLogForm
            sceneId={sceneId}
            slateId={slateId}
            takeId={takeId}
          />
        </div>
      </div>
    </div>
  }
}

const mapStateToProps = ({script, templates}) => ({
  scriptReady: script.ready,
  templatesReady: templates.ready
})

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      fetchScript,
      fetchTemplates
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Write)


// WEBPACK FOOTER //
// ./app/routes/ScriptLog/routes/Write/index.js